import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-permission-dialog',
  templateUrl: './notification-permission-dialog.component.html',
  styleUrls: ['./notification-permission-dialog.component.scss'],
  standalone: true,
  imports: [TranslatePipe],
})
export class NotificationPermissionDialogComponent {
  activeModal = inject(NgbActiveModal);

  async allow() {
    try {
      if ('Notification' in window && Notification.permission === 'default') {
        await Notification.requestPermission();
      }
    } finally {
      try {
        localStorage.setItem('notif_prompted', '1');
      } catch {}
      this.activeModal.close(true);
    }
  }

  dismiss() {
    try {
      localStorage.setItem('notif_prompted', '1');
    } catch {}
    this.activeModal.close(false);
  }
}
